import { render, staticRenderFns } from "./viewNotaFiscal.vue?vue&type=template&id=c3f9b0d8&scoped=true&"
import script from "./viewNotaFiscal.vue?vue&type=script&lang=js&"
export * from "./viewNotaFiscal.vue?vue&type=script&lang=js&"
import style0 from "./viewNotaFiscal.vue?vue&type=style&index=0&id=c3f9b0d8&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3f9b0d8",
  null
  
)

export default component.exports